import styled from 'styled-components';

import { getVariant } from '@/themes/typographyUtilis';

export const ToolbarStickyWrap = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 0 0 ${({ theme }) => theme.colors.border};
  border-radius: 6px 6px 0 0;
  background: ${({ theme }) => theme.colors.background.medium};
`;

export const EditorWrapper = styled.div`
  width: 100%;

  .ql-toolbar {
    display: flex;
    align-items: center;
    gap: 6px;
    border: 0;
    border-radius: 6px 6px 0 0;
    padding: 6px;
    background: ${({ theme }) => theme.colors.background.medium};
  }

  .ql-toolbar button,
  .ql-toolbar .ql-picker {
    box-shadow: none;
    border: 0;
    border-radius: 4px;
    color: ${({ theme }) => theme.colors.primaryText};
  }

  .ql-toolbar button {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    min-width: 28px;
    height: 28px;
    padding: 0 6px;
    color: ${({ theme }) => theme.colors.primaryText};
  }

  .ql-toolbar .ql-divider {
    display: inline-flex;
    width: 1px;
    height: 20px;
    margin: 0 4px;
    background: ${({ theme }) => theme.colors.border};
  }

  .ql-toolbar button:hover,
  .ql-toolbar button.ql-active {
    background: ${({ theme }) => theme.colors.background.medium};
  }

  .ql-toolbar .ql-picker-label {
    box-shadow: none;
    border: 0;

    &:hover {
      color: ${({ theme }) => theme.colors.secondaryText};
    }

    &:focus {
      box-shadow: none;
      outline: none;
      border: 0;
    }
  }

  .ql-toolbar .ql-picker.ql-header {
    width: 120px;
  }

  .ql-toolbar .ql-picker.ql-header .ql-picker-label::before,
  .ql-toolbar .ql-picker.ql-header .ql-picker-item::before {
    color: ${({ theme }) => theme.colors.primaryText};
  }

  .ql-toolbar .ql-picker.ql-header .ql-picker-label[data-value='']::before,
  .ql-toolbar .ql-picker.ql-header .ql-picker-item[data-value='']::before {
    content: 'Normal';
  }

  .ql-toolbar .ql-picker.ql-header .ql-picker-label[data-value='2']::before,
  .ql-toolbar .ql-picker.ql-header .ql-picker-item[data-value='2']::before {
    content: 'Header';
  }

  .ql-toolbar .ql-picker.ql-header .ql-picker-label[data-value='3']::before,
  .ql-toolbar .ql-picker.ql-header .ql-picker-item[data-value='3']::before {
    content: 'Subheader';
  }

  .ql-toolbar .ql-stroke {
    stroke: ${({ theme }) => theme.colors.primaryText};
  }

  .ql-toolbar .ql-fill {
    fill: ${({ theme }) => theme.colors.primaryText};
  }

  .ql-toolbar button:hover .ql-stroke,
  .ql-toolbar button.ql-active .ql-stroke {
    stroke: ${({ theme }) => theme.colors.secondaryText};
  }

  .ql-toolbar button:hover .ql-fill,
  .ql-toolbar button.ql-active .ql-fill {
    fill: ${({ theme }) => theme.colors.secondaryText};
  }

  .ql-toolbar .ql-picker-label:hover .ql-stroke {
    stroke: ${({ theme }) => theme.colors.secondaryText};
  }

  .ql-toolbar .ql-picker-label:hover .ql-fill {
    fill: ${({ theme }) => theme.colors.secondaryText};
  }

  .ql-picker-options {
    border: 1px solid ${({ theme }) => theme.colors.border} !important;
    background: ${({ theme }) => theme.colors.background.light};

    .ql-picker-item {
      &:hover {
        color: ${({ theme }) => theme.colors.secondaryText};
      }

      &:hover .ql-stroke {
        stroke: ${({ theme }) => theme.colors.secondaryText};
      }

      &:hover .ql-fill {
        fill: ${({ theme }) => theme.colors.secondaryText};
      }
    }
  }

  .ql-toolbar .ql-picker-label.ql-active,
  .ql-toolbar .ql-picker.ql-expanded .ql-picker-label {
    color: ${({ theme }) => theme.colors.primaryText};
  }

  .ql-toolbar .ql-picker-label.ql-active .ql-stroke,
  .ql-toolbar .ql-picker.ql-expanded .ql-picker-label .ql-stroke {
    stroke: ${({ theme }) => theme.colors.primaryText};
  }

  .ql-toolbar .ql-picker-label.ql-active .ql-fill,
  .ql-toolbar .ql-picker.ql-expanded .ql-picker-label .ql-fill {
    fill: ${({ theme }) => theme.colors.primaryText};
  }

  .ql-tooltip {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: 6px;
    padding: 8px;
    background: ${({ theme }) => theme.colors.background.light};
    color: ${({ theme }) => theme.colors.primaryText};
    font-size: 12px;
  }

  .ql-tooltip input[type='text'] {
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: 6px;
    padding: 6px 8px;
    background: ${({ theme }) => theme.colors.background.light};
    color: ${({ theme }) => theme.colors.primaryText};
  }

  .ql-tooltip input[type='text']::placeholder {
    color: ${({ theme }) => theme.colors.secondaryText};
  }

  .ql-tooltip a {
    margin-left: 8px;
    color: ${({ theme }) => theme.colors.active};
    font-weight: 600;
    text-decoration: none;
  }

  .ql-editor a {
    color: ${({ theme }) => theme.colors.teal};
    text-decoration: underline;
  }

  .ql-tooltip a:hover {
    color: ${({ theme }) => theme.colors.secondaryText};
  }

  .ql-editor a:hover {
    opacity: 0.9;
  }

  .ql-container {
    border: 0;
    border-radius: 0 0 6px 6px;
  }

  .ql-editor {
    overflow-y: auto;
    min-height: 160px;
    border-radius: 0 0 6px 6px;
    padding: 12px 14px;
    background: ${({ theme }) => theme.colors.background.light};
    color: ${({ theme }) => theme.colors.primaryText};
    ${getVariant({ variant: 'body1-normal' })}
    text-align: left;
    white-space: pre-wrap;
  }

  .ql-editor:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.active};
  }

  .ql-editor.ql-blank::before {
    left: 14px;
    color: ${({ theme }) => theme.colors.secondaryText};
    font-style: normal;
  }

  .ql-editor h2 {
    margin: 0 0 12px;
    color: ${({ theme }) => theme.colors.primaryText};
    ${getVariant({ variant: 'h2' })}
  }

  .ql-editor h3 {
    margin: 0 0 10px;
    color: ${({ theme }) => theme.colors.primaryText};
    ${getVariant({ variant: 'h3' })}
  }

  .ql-editor table {
    margin: 8px 0;
    border-collapse: collapse;
  }

  .ql-editor .ql-table-temporary,
  .ql-editor table > p,
  .ql-editor table > br {
    display: none;
  }

  .ql-editor td,
  .ql-editor th {
    border: 1px solid ${({ theme }) => theme.colors.border};
    padding: 6px 8px;
    color: ${({ theme }) => theme.colors.primaryText};
    vertical-align: top;
  }

  .ql-editor td p,
  .ql-editor th p {
    margin: 0;
  }
`;
